'use strict';


class LocationController {
    /*@ngInject*/
    constructor ($scope, $stateParams, $state, orderStore, $q, $timeout, utils) {
        "ngInject";
        _.extend(this, {
            $scope: $scope,
            $stateParams: $stateParams,
            $state: $state,
            $q: $q,
            orderStore: orderStore,
            locationMapId: 'embedded-map',
            utils: utils
        });
        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId)
            .then(
                (order) => {
                    this.order = order;
                    $timeout(() => this.initialiseMapServices());
                },
                (error) => this.$q.reject(error)
            );
    }

    enterKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.goToPayment();
        }
    }

    /**
     * API docs can be found at https://developers.google.com/maps/documentation/javascript/places#place_details
     */
    initialiseMapServices () {
        this.map = new google.maps.Map(document.getElementById(this.locationMapId), {
            center: {lat: -33.866, lng: 151.196},
            zoom: 17
        });
        this.placeService = new google.maps.places.PlacesService(this.map);
        this.addLocalityMarkersToMap();
    }

    addLocalityMarkersToMap () {
        let markers = [this.order.from_address.place_id, this.order.to_address.place_id];

        if (_.filter(markers, _.isUndefined).length) {
            return false;
        }

        let places = _.map(markers, (marker) => this.getLatLongFromPlaceId(marker));
        this.$q.all(places)
            .then((response) => this.addLatLongToAddress(response))
            .then((response) => this.createMarkers(response));
    }

    getLatLongFromPlaceId (placeId) {
        let request = {placeId: placeId},
            deferred = this.$q.defer();
        this.placeService.getDetails(request, (response) => deferred.resolve(response));
        return deferred.promise;
    }

    /**
     * places is expected to be [from address, to address] in that order
     * @param {[type]} places [description]
     */
    addLatLongToAddress (places) {
        this.order.from_address.latitude = places[0].geometry.location.lat();
        this.order.from_address.longitude = places[0].geometry.location.lng();

        this.order.to_address.latitude = places[1].geometry.location.lat();
        this.order.to_address.longitude = places[1].geometry.location.lng();

        return places;
    }

    /**
     * Add locality markers to map
     * @param  {[GooglePlace]} places A list ofplaces retrieved from processLatLongFromRequest
     */
    createMarkers (places) {
        let bounds = new google.maps.LatLngBounds();

        for (let i = 0, place; place = places[i]; i++) {
            let image = {
                size: new google.maps.Size(71, 71),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(17, 34),
                scaledSize: new google.maps.Size(25, 25)
            };

            let marker = new google.maps.Marker({
                map: this.map,
                icon: image,
                title: place.name,
                position: place.geometry.location
            });

            bounds.extend(place.geometry.location);
        }
        this.map.fitBounds(bounds);
        return places;
    }

    getUpdatedOrder(status = this.orderStore.status.CONFIRMED) {
        let order = _.cloneDeep(this.order);
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);

        /**
         * Update the status as confirmed / finalized to ensure that
         *  a bill is generated for this order.
         */
        order.status = status;

        return order;
    }

    checkIfValidForm() {
        const form = this.locationForm;

        // Set form as submitted
        form.$setSubmitted();

        return form.$valid;
    }

    goToQuotes () {
        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.QUOTED))
            .then(
                (order) => {
                    let quotePage = this.utils.getQuotePageForOrderWith(order.move_type, order.property_type);
                    let nextState = this.utils.getAdminStateIfApplicable(quotePage);
                    this.$state.go(nextState, {orderId: order.id})
                },
                (error) => console.log(error)
            );
    }

    goToPayment () {
        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }

        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder())
            .then(
                (order) => {
                    let nextState = this.utils.getAdminStateIfApplicable('base.payment');
                    this.$state.go(nextState, {orderId: order.id});
                }
            );
    }

}

export default LocationController;


// WEBPACK FOOTER //
// ./client/app/components/location/location.controller.js